import moment from 'moment';

import { CurrentUser } from '../../../rematch-models/user';

const SCHEDULED_TIME_DISPLAY_FORMAT = 'D-MMM-YY, hh:mm a, z';

export const formatScheduledTimeForDisplay = ({
  scheduledTime,
  user,
}: {
  scheduledTime: string;
  user: CurrentUser;
}) =>
  moment
    .tz(moment(scheduledTime).toISOString(), user.localTimezone)
    .format(SCHEDULED_TIME_DISPLAY_FORMAT);
